import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { decryptFields } from "../../utils/kycStatus";
import { useDispatch, useSelector } from "react-redux";
import { portfolioApi } from "../../redux/features/portfolio/portfolioSlice";
import { IoInformationCircleOutline } from "react-icons/io5";
import CustomButton from "../../components/CustomButton";
import Loader from "../../components/Loader";
import axiosInstance from "../../utils/axiosInstance";
import Button from "../../components/common/Button";

const ProductDetails = () => {
  const { id: skuID } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    deliveryAndCharges,
    buyBtn,
    productDetails,
    weight,
    metalPurity,
    skuId,
    desc,
  } = t("productDetailsPage");
  const navigate = useNavigate();
  const location = useLocation();
  const [coinData, setCoinData] = useState(null);
  const [isGoldInsufficient, setIsGoldInsufficient] = useState(false);

  const {
    purity,
    productWeight,
    sku,
    description,
    basePrice,
    metalType,
    name,
  } = location?.state;

  const isGold = metalType == "gold" ? true : false;

  const [mainImage, setMainImage] = useState(null);

  const portfolioApiResponse = useSelector(
    (state) => state.portfolioSlice.data
  );

  const { balQuantity: goldInLocker } =
    portfolioApiResponse?.[0]?.augmont.gold || {};
  const { balQuantity: silverInLocker } =
    portfolioApiResponse?.[0]?.augmont.silver || {};

  useEffect(() => {
    productDetailApi();
    dispatch(portfolioApi());
  }, [dispatch]);

  // useEffect(() => {
  //   productDetailApi();
  // }, [skuID]);

  const [loading, setLoading] = useState(true);

  const productDetailApi = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(`/products/show-product/${sku}`);
      const { data, error, message } = res.data;
      if (!error) {
        setCoinData(data[0]?.result?.data);
        setMainImage(data[0]?.result?.data?.productImages[0]?.url);
      } else {
        Swal.fire({
          icon: "error",
          text: message || "Something Went Wrong!!!",
        });
      }
    } catch (error) {
      console.error("Error connecting to API", error);
      Swal.fire({
        icon: "error",
        text: error?.response?.data?.message || "Something Went Wrong!!!",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleImageClick = (index) => {
    if (coinData) {
      const clickedImage = coinData.productImages[index].url;
      setMainImage(clickedImage);
    }
  };

  const [userDetails, setUserDetails] = useState({
    pan: false,
    address: false,
  });

  const [kycDone, setKycDone] = useState(false);

  useEffect(() => {
    const storedDetails = JSON.parse(localStorage.getItem("userDetails")) || {};

    const decryptedDetails = decryptFields(storedDetails, ["pan", "address"]);

    setUserDetails({
      pan: decryptedDetails.pan || false,
      bank: decryptedDetails.bank || false,
      address: decryptedDetails.address || false,
    });

    if (decryptedDetails.pan === true && decryptedDetails.address === true) {
      setKycDone(true);
    }
  }, []);

  // const checkBalanceInLocker = () => {
  //   if (isGold) {
  //     if (goldInLocker != null && coinData?.productWeight != undefined) {
  //       if (goldInLocker >= coinData.productWeight) {
  //         navigate("/dashboard/shippingAddress", {
  //           state: { ...location.state, coinData },
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Insufficient gold in locker",
  //           text: "Insufficient gold in locker to process the order.",
  //         });
  //       }
  //     } else {
  //       toast.warning("Gold locker balance or coin data is unavailable.");
  //     }
  //   } else {
  //     if (silverInLocker != null && coinData?.productWeight != undefined) {
  //       if (silverInLocker >= coinData.productWeight) {
  //         // toast.success("Sufficient silver in locker to process the order.");
  //         navigate("/dashboard/shippingAddress", {
  //           state: { ...location.state, coinData },
  //         });
  //       } else {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Insufficient silver in locker",
  //           text: "Insufficient silver in locker to process the order.",
  //         });
  //       }
  //     } else {
  //       toast.warning("Silver locker balance or coin data is unavailable.");
  //     }
  //   }
  // };

  const handleBuyNow = () => {
    navigate("/dashboard/shippingAddress", {
      state: { ...location.state, coinData },
    });
  };

  // useEffect(() => {
  //   if (goldInLocker < productWeight) {
  //     setIsGoldInsufficient(true);
  //   } else {
  //     setIsGoldInsufficient(false);
  //   }
  // }, [goldInLocker, productWeight]);

  useEffect(() => {
    const lockerWeight = isGold ? goldInLocker : silverInLocker;
    setIsGoldInsufficient(lockerWeight < productWeight);
  }, [goldInLocker, silverInLocker, productWeight, isGold]);

  return (
    <>
      {loading ? (
        <div style={{ height: "90vh" }}>
          <Loader />
        </div>
      ) : (
        <div className="row">
          <div
            className="col-md-4"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="row text-center">
              <div
                className="col-md-12"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div className="row">
                  <div className="c-l-md-12">
                    <img
                      className="img-fluid"
                      style={{ width: 170 }}
                      src={mainImage}
                      alt="img"
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    <div className="d-flex justify-content-evenly align-items-center flex-wrap">
                      {coinData.productImages.map((image, index) => (
                        <div
                          key={index}
                          // className="img-thumbnail mt-1 contentshadow"
                          style={{
                            width: "50px",
                            // backgroundColor: "red",
                            borderRadius: "5px",
                            border: "2px solid gold",
                            padding: "0.3rem",
                          }}
                        >
                          <img
                            // style={{ height: 60 }}
                            width="100%"
                            src={image.url}
                            alt={coinData.title}
                            onClick={() => handleImageClick(index)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="col-12">
                    <div>
                      <h5 className="mt-2">
                        {isGold ? "Gold" : "Silver"} Coin | {productWeight} Gms
                        | {purity} Purity
                      </h5>
                      {/* <h5 className="mt-2">{name}</h5> */}
                      <p className="mt-2">{deliveryAndCharges}</p>
                      <p>&#8377;{basePrice} (All Incl.)</p>
                    </div>

                    <div
                      style={{
                        margin: "1rem 0",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {kycDone ? (
                        <div>
                          <Button
                            label="BUY NOW"
                            onClick={handleBuyNow}
                            disabled={isGoldInsufficient}
                          />
                        </div>
                      ) : (
                        <Link to="/dashboard/profile/profileSetting">
                          <CustomButton label="Complete KYC" />
                        </Link>
                      )}
                    </div>
                    {isGoldInsufficient && (
                      <div
                        style={{
                          margin: "1rem 0",
                          color: "red",
                          fontWeight: "500",
                        }}
                      >
                        You do not have sufficient {metalType} in your locker to
                        complete this purchase.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8" style={{ textAlign: "center" }}>
            <div className="universal_card mb-4">
              <h5 style={{ textAlign: "center" }}>{productDetails}</h5>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  marginTop: "1rem",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>{weight}</div>
                    <div>{productWeight} gm</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Tooltip
                      title="Metal purity indicates the percentage of gold in the ornament, e.g., 24K = 99.9% pure."
                      enterTouchDelay={0}
                      leaveTouchDelay={3000}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          gap: "8px",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <div>{metalPurity}</div>
                        <div>
                          <IoInformationCircleOutline
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </div>
                    </Tooltip>
                    <div> {purity}</div>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "0.5rem",
                        alignItems: "center",
                      }}
                    >
                      <div>{skuId}</div>
                      <Tooltip title="The SKU (Stock Keeping Unit) ID uniquely identifies this product for inventory and tracking purposes.">
                        <div>
                          <IoInformationCircleOutline
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </Tooltip>
                    </div>

                    <div>{sku}</div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="universal_card">
              <div style={{ marginBottom: "1rem" }}>
                <h5>{desc}</h5>
              </div>
              <p style={{ marginTop: "1rem" }}>{description}</p>
            </div>
            <div style={{ margin: "1rem 0" }}>
              <p>
                {productWeight}gm {metalType} will be deducted from your locker.
                ₹{basePrice} will be charged for delivery and making.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetails;
